export default __webpack_public_path__ + "img/sandeep-pal.c8c04ac2.png";